module.exports = __webpack_public_path__ + "img/depmap_svg_V98.483db859.svg";